"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScriptType = void 0;
const list_source_hook_1 = require("../../../utils/list-source-hook");
function useScriptType() {
    return list_source_hook_1.useStaticListSource([
        { id: 'GROOVY', name: 'Groovy' },
        { id: 'JAVASCRIPT', name: 'Javascript' },
    ]);
}
exports.useScriptType = useScriptType;
//# sourceMappingURL=admin-console-api.js.map